<template>
  <div class="catalog__category-list">
    <div class="_loading" v-if="isLoading">
      <div class="_spinner"></div>
    </div>
    <div class="page messages" v-show="products.length === 0">
      <ul>
        <li class="message warning">{{ $t('No products were found.') }}</li>
      </ul>
    </div>
    <ul class="grid-x grid-padding-x">
      <product-list-item v-for="(product, index) in products"
                         :data-source="dataSource"
                         :product="product"
                         :list-index="index"
                         :showSpecs="true"
                         :key="product.product_id || product.entity_id || index">
      </product-list-item>
    </ul>
  </div>
</template>

<script lang="ts">
import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';
import {enhancedEcommerce} from '../../shared/helpers/enhanced-ecommerce';
import {SolarDataLayer} from '@flashpointbv/solar-datalayer/dist';

@Component({
  name: 'catalog-product-list',
  components: {
    'product-list-item': ServiceContainer().getComponent('catalog-product-list-item')
  }
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;

  get isLoading(): boolean {
    return this.$store.getters[`${this.dataSource}/isLoading`];
  }

  get products(): Array<object> {
    return this.$store.getters[`${this.dataSource}/productList`];
  }

  private created(): void {
    enhancedEcommerce.addProductImpressions(this.products);
    SolarDataLayer.init().addViewItemsList(this.products, 'Product list');
  }

  private updated(): void {
    this.$nextTick(() => {
      ('.catalog__category-list a').matchHeight(true);
      ('.catalog__category-list .product__holder').matchHeight(true);
      ('.price__holder').matchHeight(true);
      const resizeEvent = new UIEvent('resize');
      window.dispatchEvent(resizeEvent);
    });
  }
}
</script>
